
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneLink from '../PhoneLink';
import SkynetIcon from "../Fundamentals/SkynetIcon";
import ToolTip, { TooltipContent, TooltipTrigger } from "../Overlays/Tooltip";

function MyAppointmentTable ({appointments, closed, sortListByKey, moveToDetails, getClassNameForStatus}) {
    const {t} = useTranslation();
    const sort = sortList();
    const sortOrder = sort.sortOrder === "asc" ? <SkynetIcon icon={"vismaicon-sm vismaicon-arrow-up-circle"}/> : <SkynetIcon icon={"vismaicon-sm vismaicon-arrow-down-circle"}/>;
    const sortKey = sort.key;

    function sortList() {
        const jsonSort = localStorage.getItem("sortOrder_myFilteredOpenAppointments");
        return jsonSort ? JSON.parse(jsonSort) : [];
    }

    return <table className="table table-stripe table-hover table-appointments">
        <thead>
        <tr>
            <th className="text-left sortable"
                onClick={() => sortListByKey('customerName')}>{t('myopenappointmentstable.customername')} {sortKey === 'customerName' &&
                <span>{sortOrder}</span>}</th>
            <th className="text-left sortable"
                onClick={() => sortListByKey('customerNumber')}>{t('myopenappointmentstable.customernumber')} {sortKey === 'customerNumber' &&
                <span>{sortOrder}</span>}</th>
            <th className="text-left sortable"
                onClick={() => sortListByKey('email')}>{t('myopenappointmentstable.email')} {sortKey === 'email' &&
                <span>{sortOrder}</span>}</th>
            <th className="text-left sortable"
                onClick={() => sortListByKey('phoneNumber')}>{t('myopenappointmentstable.phonenumber')} {sortKey === 'phoneNumber' &&
                <span>{sortOrder}</span>}</th>
            <th className="text-left sortable"
                onClick={() => sortListByKey('time')}>{t('myopenappointmentstable.time')} {sortKey === 'time' &&
                <span>{sortOrder}</span>}</th>
            <th className="text-left sortable"
                onClick={() => sortListByKey('subject')}>{t('myopenappointmentstable.subject')} {sortKey === 'subject' &&
                <span>{sortOrder}</span>}</th>
            <th>{t('myopenappointmentstable.comment')}</th>
            {closed && <th className="text-left sortable"
                           onClick={() => sortListByKey('reason')}>{t('myopenappointmentstable.reason')} {sortKey === 'reason' &&
                <span>{sortOrder}</span>}</th>}
            <th className="text-center" width="50"></th>
        </tr>
        </thead>
        <tbody>
        {appointments.map((appointment, index) => {
            return <tr key={index} onClick={() => moveToDetails(appointment.id)}>
                <td>{appointment.customerName ? appointment.customerName : 'N/A'}</td>
                <td>{appointment.customerNumber ? appointment.customerNumber : 'N/A'}</td>
                <td>{appointment.emailAddress}</td>
                <td>{appointment.phoneNumber} {appointment.phoneNumber &&
                    <PhoneLink phoneNumber={appointment.phoneNumber} icon={true}/>}</td>
                <td>{appointment.time}</td>
                <td>{appointment.subject}</td>
                <td>
                    {appointment.comments && appointment.comments.length > 20 ? (
                        <ToolTip>
                            <TooltipTrigger className="h-100 d-flex align-items-center">
                               <p className="m-0">{appointment.comments.slice(0, 20)}...</p>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p className="m-0 text-left" style={{ whiteSpace: 'pre-wrap' }}>{appointment.comments}</p>
                            </TooltipContent>
                        </ToolTip>
                    ) : (
                        <p className="m-0">{appointment.comments || ''}</p>
                    )}
                </td>
                {closed && <td>{appointment.reason}</td>}
                <td className="text-center"><span className={getClassNameForStatus(appointment)}></span></td>
            </tr>
        })}
        </tbody>
    </table>
}

export default MyAppointmentTable;
